'use client'
import {ReactNode} from "react";
import {RepositoryRegistry} from "@web-libs/core/repositories/application/repository-registry";
import {useHttpContext} from "@web-libs/core/http/infrastructure/client-side/http.context";
import {RepositoryContext} from "@web-libs/core/repositories/application/repository-context";
import {createRemoteUserRepository} from "@web-libs/features/users/api/user-remote.repository";
import {createTrmzFileDTOConverter} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";
import {useInitOnce} from "@web-libs/util/hooks/use-init-once";
import {createProfileRepository} from "@web-libs/features/profile/api/profile-remote";
import {
    createAppointmentRepository, createCategoryRepository, createSpecializationRepository
} from "@web-libs/features/appointments/api/appointment-remote.repository";
import {createSpecializationRepository as createGeneralSpecializationRepository} from "@web-libs/features/specializations/api/remote-specialization.repository";
import {createVideoRepository} from "@web-libs/features/video/api/create-video.repository";
import {createCmsRepository} from '@web-libs/features/cms/api/cms.repository';
import {createInstitutionRepository} from "@web-libs/features/institution/api/institution.repository";
import { createInformationRepository } from '@web-libs/features/information/api/information.repository';

export const RepositoryProvider = ({children, tenantId} : {children: ReactNode, tenantId:string}) => {
    const httpConcern = useHttpContext()

    const trmzFileConverter = createTrmzFileDTOConverter(httpConcern.baseUrl, tenantId)
    const informationRepository = createInformationRepository(httpConcern,trmzFileConverter)

    const appointmentRepository = useInitOnce(() => createAppointmentRepository(httpConcern, trmzFileConverter))

    const instRepo = createInstitutionRepository(httpConcern)

    const repositoryRegistry = new RepositoryRegistry({
        InformationRepository: informationRepository,
        AppointmentRepository: appointmentRepository,
        //UserRepository: createRemoteUserRepository(httpConcern, trmzFileConverter)
        UserRepository: createRemoteUserRepository(httpConcern, trmzFileConverter),
        SpecializationRepository: createSpecializationRepository(httpConcern),
        GeneralSpecializationRepository: createGeneralSpecializationRepository(httpConcern),
        AppointmentCategoryRepository: createCategoryRepository(httpConcern),
        ProfileRepository: createProfileRepository(httpConcern),
        VideoRepository: createVideoRepository(httpConcern),
        CmsRepository: createCmsRepository(httpConcern),
        InstitutionRepository: instRepo
    })

    return <RepositoryContext.Provider value={repositoryRegistry}>
        {children}
    </RepositoryContext.Provider>
}
